/* src/assets/styles/common.css */
.flex {
  display: flex;
}
.flex-row {
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex.jc-e {
  justify-content: end;
}
.flex.jc-c {
  justify-content: center;
}
.flex.jc-sb {
  justify-content: space-between;
}
.flex.align-c {
  align-items: center;
}
.flex.align-fe {
  align-items: flex-end;
}
.flex.align-fs {
  align-items: flex-start;
}
.flex.gap-10 {
  gap: 10px;
}
.flex.gap-20 {
  gap: 20px;
}
.flex.gap-50 {
  gap: 50px;
}
.ac-fs {
  align-content: flex-start;
}
.text-align-center {
  text-align: center;
}
.text-align-right {
  text-align: right;
}
.container {
  padding: 1rem;
}
.mg-t-5 {
  margin-top: 5px;
}
.mg-t-10 {
  margin-top: 10px;
}
.mg-r-10 {
  margin-top: 20px;
}
.width100 {
  width: 100%;
}
.width90 {
  width: 90%;
}
.bold {
  font-weight: 800;
}
.col-1 {
  width: calc(100% * 1 / 12);
}
.col-2 {
  width: calc(100% * 2 / 12);
}

/* src/app/modules/tube/components/tube/tube.component.scss */
sh-spinner {
  margin: auto;
}
:host {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.empty {
  padding: 1rem;
  display: flex;
  min-height: 200px;
  flex-direction: column;
  font: var(--body-1);
  align-items: center;
}
.empty > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  gap: 1rem;
}
.empty > div > span {
  text-align: center;
}
.empty app-back-to-system-overview {
  margin-top: 1rem;
  display: initial;
}
/*# sourceMappingURL=tube.component.css.map */
